import { render, staticRenderFns } from "./CardNota.vue?vue&type=template&id=80382bf8&scoped=true&"
import script from "./CardNota.vue?vue&type=script&lang=js&"
export * from "./CardNota.vue?vue&type=script&lang=js&"
import style0 from "./CardNota.vue?vue&type=style&index=0&id=80382bf8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80382bf8",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./modules/Home/views/src/components/CardNota.vue
// module id = 379
// module chunks = 0